/* KIWABI article tables: DOM-only enhancement, no tracking or network calls. */
(function () {
  'use strict';
  if (window.__kiwabiArticleTablesV1) return;
  window.__kiwabiArticleTablesV1 = true;
  var records = [];
  var frame = 0;
  function update() {
    frame = 0;
    records = records.filter(function (record) {
      if (!record.wrap.isConnected) {
        if (observer) { observer.unobserve(record.wrap); observer.unobserve(record.table); }
        return false;
      }
      var overflowing = record.wrap.scrollWidth > record.wrap.clientWidth + 2;
      record.hint.hidden = !overflowing;
      if (overflowing) {
        record.wrap.setAttribute('tabindex', '0');
        record.wrap.setAttribute('role', 'region');
        record.wrap.setAttribute('aria-label', record.label);
      } else {
        record.wrap.removeAttribute('tabindex');
        record.wrap.removeAttribute('role');
        record.wrap.removeAttribute('aria-label');
      }
      return true;
    });
  }
  function queue() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }
  var observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(queue) : null;
  function initialize(scope) {
    scope.querySelectorAll('[data-kiwabi-readability] .blog__article__content table').forEach(function (table) {
      if (table.closest('.kiwabi-table-scroll') || table.closest('[data-kiwabi-table-ignore]')) return;
      if (table.parentElement.closest('table') || table.getAttribute('role') === 'presentation') return;
      var parent = table.parentElement;
      var overflow = window.getComputedStyle(parent).overflowX;
      if (overflow === 'auto' || overflow === 'scroll') return;
      var wrap = document.createElement('div');
      wrap.className = 'kiwabi-table-scroll';
      var hint = document.createElement('p');
      hint.className = 'kiwabi-table-hint';
      hint.hidden = true;
      hint.textContent = document.documentElement.lang.indexOf('ja') === 0 ? '表は左右にスクロールできます。' : 'Scroll horizontally to read the table.';
      var caption = table.caption ? table.caption.textContent.trim() : '';
      var label = caption || (document.documentElement.lang.indexOf('ja') === 0 ? '表（左右にスクロールできます）' : 'Table (scroll horizontally)');
      parent.insertBefore(wrap, table);
      wrap.appendChild(table);
      wrap.insertAdjacentElement('afterend', hint);
      records.push({ wrap: wrap, table: table, hint: hint, label: label });
      if (observer) { observer.observe(wrap); observer.observe(table); }
    });
    queue();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', queue);
  window.addEventListener('resize', queue, { passive: true });
}());
